import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from '@paypalcorp/pp-react';
import { trackActivityEvent, trackJSError } from '../helpers/analytics/fptiHelper';
import ErrorMessage from './ErrorMessage';

/*
  Error Boundary component to handle/catch error in the child components.
  Error boundaries catch errors during rendering, in lifecycle methods,
  and in constructors of the whole tree below them, unmount the component tree
  while maintaining the usual workings and renderings of the rest of the React application.
 */
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: '',
      errorInfo: '',
      hasError: false,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    const { errorFPTI } = this.props;
    this.setState({
      error,
      errorInfo,
    });
    if (errorFPTI) {
      trackActivityEvent(this.props.errorFPTI);
    } else {
      trackActivityEvent(); // TODO:: set some default FPTI to catch errors
    }

    trackJSError({ error: JSON.stringify(error), errorInfo });
  }

  render() {
    if (!this.state.errorInfo) {
      return this.props.children;
    }

    if (this.props.suppressError) {
      return <div />;
    }

    return (
      <Container>
        <ErrorMessage />
      </Container>
    );
  }
}

ErrorBoundary.propTypes = {
  suppressError: PropTypes.bool,
  children: PropTypes.node,
  errorFPTI: PropTypes.shape({}), // Custom error FPTI corresponding to the component.
  // componentName: PropTypes.string,
};

ErrorBoundary.defaultProps = {
  suppressError: false,
};

export default ErrorBoundary;
